export default "__VITE_ASSET__BKGrqOxR__"